import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericConfirmationModalModel } from '@bo-client/shared/models/genericConfirmationModal.model';

@Component({
  selector: 'app-generic-two-options-modal',
  templateUrl: './generic-two-options-modal.component.html',
  styleUrls: ['./generic-two-options-modal.component.scss']
})
export class GenericTwoOptionsModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<GenericTwoOptionsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: GenericConfirmationModalModel
  ) {}

  ngOnInit(): void {}

  cancel() {
    this.dialogRef.close(null);
  }

  optionA() {
    this.dialogRef.close('optionA');
  }

  optionB() {
    this.dialogRef.close('optionB');
  }
}
